import { Navigate, Outlet, createFileRoute } from "@tanstack/react-router";
import { useAdminAuth } from "@/features/admin/hooks/useAdminAuth";
import { Skeleton } from "@/shared/ui/Skeleton";

/**
 * Pathless layout that gates admin routes behind a valid admin session.
 * The login route (`/admin/login`) lives outside this layout and is public.
 *
 * As with `_authenticated.tsx`, we use `<Navigate>` (not `throw redirect()`)
 * because the admin token is validated via an async Convex query — auth state
 * isn't synchronously available at navigation time.
 */
export const Route = createFileRoute("/_adminGuarded")({
  component: AdminGuardedLayout,
});

function AdminGuardedLayout() {
  const { state } = useAdminAuth();

  if (state.status === "loading") {
    return (
      <div className="min-h-screen bg-bg flex flex-col items-center justify-center gap-3 px-4">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-4 w-64" />
      </div>
    );
  }

  if (state.status === "anonymous") {
    return <Navigate to="/admin/login" />;
  }

  return <Outlet />;
}
